module.exports = __webpack_public_path__ + "img/engage-fig-1.b9017a33.png";